// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @ commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ components
const { CallMeBack } = require('components/callMeBack/callMeBack');
const AccountAddDocumentationSuccess = require('./accountAddDocumentationSuccess/accountAddDocumentationSuccess');
const AccountAddDocumentationError = require('./accountAddDocumentationError/accountAddDocumentationError');
const AccountAddDocumentationUpload = require('./accountAddDocumentationUpload/accountAddDocumentationUpload');

// @ utilities
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const {
    PROC_CONTRACTS,
    PROC_START,
    recordPath,
} = require('utilities/tagging');

const {
    getAccountNameProduct,
    getAccountPath,
} = require('utilities/accountAddDocumentationTaggingHelper');

// @ actions
const accountAddDocumentationActions = require('actions/accountAddDocumentation');
const intervenersActions = require('actions/getAccountInterveners');

// @ constants
const {
    HIRE_ACCOUNTS_ADD_DOCUMENTATION,
} = require('constants/flagBasedFeatures');

class AccountAddDocumentationView extends React.Component {

    componentDidMount() {
        const {
            getTramitationExpedient,
            history,
            immAccounts,
            immAccountAddDocumentation,
            immFlagBasedFeatures,
            immGlobalPosition,
            match: { params: { accountId } },
            requestAccountInterveners,
            setAccountInfo,
        } = this.props;

        if (!immGlobalPosition.get('isFetching')) {
            const addDocDisabled = !immFlagBasedFeatures.get(HIRE_ACCOUNTS_ADD_DOCUMENTATION);
            const hasOneHolder = immAccountAddDocumentation.get('hasOneHolder');
            let expedientNumber = immAccountAddDocumentation.get('expedientNumber');
            let subtype = immAccountAddDocumentation.get('subtype');

            if (!expedientNumber || !subtype) {
                const immAccount = immAccounts.getIn(['byId', accountId]);

                if (!!immAccount) {
                    expedientNumber = immAccount.getIn(['ibanComplex', 'codbban']);
                    subtype = immAccount.getIn(['catalogData', 'subtype']);

                    let accountInfo = {
                        accountId,
                        accountNumber: immAccount.get('iban'),
                        alias: immAccount.get('alias'),
                        expedientNumber,
                        hasOneHolder,
                        subtype,
                    };

                    if (!hasOneHolder && !immAccount.getIn(['interveners', 'fetchSuccess'])) {
                        requestAccountInterveners(accountId).then(() => {
                            accountInfo.hasOneHolder = immAccount.getIn(['interveners', 'list']).size === 1;
                            setAccountInfo(accountInfo);
                        });
                    } else {
                        setAccountInfo(accountInfo);
                    }
                } else {
                    history.push('/myprofile/accounts');
                }
            }

            if (!expedientNumber || addDocDisabled) {
                history.push('/myprofile/accounts');
            } else {
                getTramitationExpedient(expedientNumber);
                recordPath(getAccountPath(subtype), '', PROC_CONTRACTS, PROC_START, getAccountNameProduct(subtype));
            }
        }
    }

    componentWillUnmount() {
        if (!this.props.immGlobalPosition.get('isFetching')) {
            this.props.resetUploadDocument();
        }
    }

    buildContent() {
        const {
            addFile,
            changeFileName,
            immAccountAddDocumentation,
            removeFile,
            setErrorFile,
            uploadDocumentation,
        } = this.props;

        return (
            <React.Fragment>
                <div className="col-xs-12 col-md-8">
                    <div className="row">
                        <div className="col-md-12">
                            <OKSectionBox>
                                <AccountAddDocumentationUpload
                                    addFile={addFile}
                                    changeFileName={changeFileName}
                                    immAccountAddDocumentation={immAccountAddDocumentation}
                                    removeFile={removeFile}
                                    setErrorFile={setErrorFile}
                                    uploadDocumentation={uploadDocumentation}
                                />
                            </OKSectionBox>
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-md-4">
                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-12">
                            <CallMeBack pageTitle={formatText('breadcrumb-accounts')} />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    render() {
        const {
            immAccounts,
            immAccountAddDocumentation,
            immVariables,
            match: { params: { accountId } },
            resetUploadDocument,
            retryUploadDocumentation,
        } = this.props;
        const immAccount = immAccounts.getIn(['byId', accountId]);
        const pageTitleKey = 'breadcrumb-breadcrumb_uploadDocumentation';
        let content;
        let sectionContent;

        const mappingBreadcrumb = [{
            text: formatText('breadcrumb-accounts'),
            url: '/myprofile/accounts',
        }, {
            text: immAccountAddDocumentation.get('alias'),
            url: `/myprofile/accounts/${accountId}/movements`,
        }, {
            text: formatText(pageTitleKey),
            url: '',
        }];

        if (immAccountAddDocumentation.get('error')) {
            sectionContent = (
                <AccountAddDocumentationError
                    immAccountAddDocumentation={immAccountAddDocumentation}
                    immVariables={immVariables}
                    retryUploadDocumentation={retryUploadDocumentation}
                />
            );
        } else if (
            !immAccountAddDocumentation.get('fetchSuccess') ||
            immAccountAddDocumentation.get('inProgress') ||
            immAccountAddDocumentation.get('isFetching') ||
            (!!immAccount && immAccount.getIn(['interveners', 'isFetching']))
        ) {
            sectionContent = <LoadingSection />;
        } else if (immAccountAddDocumentation.get('uploadSuccess')) {
            sectionContent = (
                <AccountAddDocumentationSuccess
                    immAccountAddDocumentation={immAccountAddDocumentation}
                    resetUploadDocument={resetUploadDocument}
                />
            );
        } else {
            sectionContent = this.buildContent();
        }

        content = (
            <React.Fragment>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover
                            size="medium"
                            section="accounts"
                            customClass="col-xs-12"
                        >
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle(pageTitleKey)}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {sectionContent}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );

        return content;
    }
}

AccountAddDocumentationView.propTypes = {
    addFile: PropTypes.func.isRequired,
    changeFileName: PropTypes.func.isRequired,
    getTramitationExpedient: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccountAddDocumentation: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immVariables: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    removeFile: PropTypes.func.isRequired,
    requestAccountInterveners: PropTypes.func.isRequired,
    resetUploadDocument: PropTypes.func.isRequired,
    retryUploadDocumentation: PropTypes.func.isRequired,
    setAccountInfo: PropTypes.func.isRequired,
    setErrorFile: PropTypes.func.isRequired,
    uploadDocumentation: PropTypes.func.isRequired,
};

module.exports.constructor = AccountAddDocumentationView;
module.exports.AccountAddDocumentationView = connect(
    state => ({
        immAccountAddDocumentation: state.accountAddDocumentation,
        immAccounts: state.accounts,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immGlobalPosition: state.globalPosition,
        immProfile: state.profile,
        immVariables: state.globalVariables.getIn(['variables', 'parameters']),
    }), {
    addFile: accountAddDocumentationActions.addFile,
    changeFileName: accountAddDocumentationActions.changeFileName,
    getTramitationExpedient: accountAddDocumentationActions.getTramitationExpedient,
    uploadDocumentation: accountAddDocumentationActions.uploadDocumentation,
    removeFile: accountAddDocumentationActions.removeFile,
    requestAccountInterveners: intervenersActions.requestAccountInterveners,
    resetUploadDocument: accountAddDocumentationActions.reset,
    retryUploadDocumentation: accountAddDocumentationActions.retryUploadDocumentation,
    setAccountInfo: accountAddDocumentationActions.setAccountInfo,
    setErrorFile: accountAddDocumentationActions.setErrorFile,
})(withRouter(AccountAddDocumentationView));
